<template>
  <div class="contaier">
    <div class="box" :class="{ scrolled: isScrolled || isNewsPage }">
      <div class="nav" @click="isOpen = true">
        <i class="iconfont icon-sanheng-copy" :style="{ color: showDark ? '#000' : '#fff'}"></i>
      </div>
      <div class="logo-box">
        <div class="logo" :class="{ 'logo--dark': showDark, 'logo--light': !showDark }" @click="goNewPage('/')"></div>
      </div>
      <!-- <div class="test-drive" @click="goNewPage('/contact-us')"></div> -->
    </div>
    <div class="mask" v-if="isOpen" @click="isOpen = false"></div>
    <!-- ===== 侧边导航面板 ===== -->
    <aside
      class="nav-panel"
      :class="{ open: isOpen }"
      :aria-hidden="isOpen ? 'false' : 'true'"
    >
      <div class="nav-head">
        <!-- <div class="nav-brand"><span class="sq"></span>iCAR</div> -->
        <button class="nav-close" @click="isOpen = false" aria-label="关闭导航">×</button>
      </div>
      <div class="isOpen-box">
        <div
          class="nav-list"
          :key="item.key"
          :style="navItemStyle(i)"
          v-for="(item, i) in computNavList"
          @click="goNewPage(item.to, item.id)"
        >
          {{ item.modelName }}
          <i class="iconfont icon-a-xiangyou4"></i>
          <div class="down-line"></div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import { throttle } from "lodash";
// import { langMixins } from '@/mixins/langMixins'
// import { imgBase } from '@/assets/js/static'
// import { modelListApi } from '@/Api/requestApi'
// import { EventBus } from '@/assets/js/event-bus'
export default {
  name: "HeadPage",
  data() {
    return {
      isOpen: false,
      isScrolled: false,
      windowWidth: 1680,
      navList: [
        { key: 1, to: "/", modelName: "首頁" },
        { key: 2, to: "/models/v23", modelName: "iCAUR V23" },
        { key: 3, to: "/models/v27", modelName: "iCAUR V27" },
        { key: 4, to: "/news", modelName: "最新消息" },
        { key: 5, to: "/koc_recruit", modelName: "KOC 招募活動" },
        { key: 6, to: "/contact-us", modelName: "聯絡我們" },
        { key: 7, to: "https://rentv23.kamlung.com/", modelName: "預約租車", external: true },
      ],
      scrollHandler: null,
      scrollPositionHandler: null,
    };
  },
  mounted() {
    // console.log('this.$route :>>hhh ', this.$route);
    this.scrollHandler = throttle(this.handleResize, 200);
    window.addEventListener("resize", this.scrollHandler);
    this.handleResize();

    this.scrollPositionHandler = throttle(this.handleScroll, 100);
    window.addEventListener("scroll", this.scrollPositionHandler);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.scrollHandler);
    window.removeEventListener("scroll", this.scrollPositionHandler);
  },
  methods: {
    handleResize() {
      let ww_ = window.innerWidth;
      // console.log('ww_ :>> ', ww_);
      // if (ww_ < 768) {
      //   this.paramH = '500px'
      // } else if (ww_ < 992) {
      //   this.paramH = '560px'
      // } else {
      //   this.paramH = '810px'
      // }

      // this.currentIndex = 0
      this.windowWidth = ww_;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
    goNewPage(p, id) {
      if (p && p.startsWith('http')) {
        window.open(p, '_blank');
        this.isOpen = false;
        return;
      }
      if (id) {
        this.$router
          .push({
            path: p,
            query: { id },
          })
          .catch(() => {});
      } else {
        this.$router.push({ path: p }).catch(() => {});
      }
      // console.log('p :>>44 ', p)
    },
    navItemStyle(i) {
      var delay = this.isOpen ? (0.4 + 7 * 0.1 - i * 0.1).toFixed(3) + "s" : "0s";
      var duration = this.isOpen ? ".5s" : ".25s";
      return {
        transitionDelay: delay,
        transitionDuration: duration,
      };
    },
  },
  computed: {
    computNavList() {
      return this.navList;
    },
    isNewsPage() {
      const path = this.$route.path.replace(/\/+$/, '') || '/';
      return path === '/news' || path === '/news/details' || path === '/koc_recruit';
    },
    showDark() {
      return this.isNewsPage || this.isScrolled;
    },
  },
};
</script>

<style lang="scss" scoped>
/* ===== 侧边导航面板 ===== */
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.45);
}
.nav-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 10002;
  width: min(460px, 32vw);
  min-width: 360px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateX(-104%);
  visibility: hidden;
  transition: transform 0.65s cubic-bezier(0.76, 0, 0.24, 1), visibility 0.65s;
  box-shadow: 28px 0 70px rgba(0, 0, 0, 0.2);
  background: linear-gradient(145deg, #fff 0%, #fafafa 100%);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 4px;
    background: #f48e30;
    transition: width 0.7s 0.2s cubic-bezier(0.76, 0, 0.24, 1);
  }

  .nav-head {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 88px;
    padding: 16px 34px 0;

    .nav-brand {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 18px;
      font-weight: 800;
      letter-spacing: 3px;
    }
    .sq {
      width: 13px;
      height: 13px;
      background: #ff5a00;
      border-radius: 2px;
      transform: rotate(45deg);
      background-color: #f5f5f7;
    }
    .nav-close {
      width: 44px;
      height: 44px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: #111;
      font-size: 38px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: color 0.3s ease, background-color 0.3s ease, transform 0.4s ease;
      font-weight: 200;
    }
    .nav-close:hover {
      background: rgba(244, 142, 48, 0.1);
      color: #f48e30;
      transform: rotate(90deg);
    }
  }
}
.nav-panel.open {
  transform: translateX(0);
  visibility: visible;

  &::before {
    width: 100%;
  }
}

.contaier {
  width: 100%;
  // padding-top: 60px;

  .box {
    width: 100%;
    height: 60px;
    position: fixed;
    align-items: center;
    left: 0;
    top: 0;
    background-color: transparent;
    backdrop-filter: blur(0px);
    z-index: 10000;
    transition: background-color 0.3s ease, backdrop-filter 0.3s ease;

    &.scrolled {
      // background-color: rgba(255, 255, 255, 0.5);
      background-color: #fafafab3;
      backdrop-filter: blur(10px);
    }
    .logo-box {
      width: 100%;
      position: relative;
      .logo {
        width: 100px;
        // margin: 10px auto;
        height: 30px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, 50%);
        // background-image: url("./../assets/img/logo.png");
        background-position: center;
        background-size: 100%;
        // background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
      }
    }
    .logo--dark  { background-image: url('@/assets/img/logo_black.svg'); }
    .logo--light { background-image: url('@/assets/img/logo_white.svg'); }
    .nav {
      width: 60px;
      // line-height: 32px;
      position: absolute;
      left: 20px;
      top: 50%;
      // border: 1px solid #333;
      // border-radius: 5px;
      text-align: center;
      transform: translate(0, -50%);
      cursor: pointer;
      .iconfont {
        // width: 100%;
        font-weight: 500;
        font-size: 28px;
        // color: #000;
      }
    }
    .test-drive {
      width: 120px;
      line-height: 32px;
      position: absolute;
      right: 20px;
      top: 50%;
      font-size: 14px;
      border: 1px solid #333;
      border-radius: 5px;
      text-align: center;
      transform: translate(0, -50%);
      cursor: pointer;
    }
  }
  .isOpen-box {
    padding: 30px 34px 48px;

    .nav-list {
      display: flex;
      align-items: center;
      min-height: 58px;
      padding: 0 14px 0 0;
      margin-bottom: 18px;
      position: relative;
      color: #171717;
      font-size: 22px;
      line-height: 1.3;
      letter-spacing: 0.04em;
      cursor: pointer;
      opacity: 0;
      transform: translateX(-48px);
      transition: opacity 0.55s ease, transform 0.65s cubic-bezier(0.22, 1, 0.36, 1), color 0.3s ease;
    }

    .icon-a-xiangyou4 {
      position: absolute;
      top: 50%;
      right: 4px;
      font-size: 24px;
      font-weight: 500;
      color: #aaa;
      transform: translateY(-50%);
      transition: color 0.3s ease, right 0.3s ease;
    }
    .down-line {
      width: 0;
      height: 1px;
      position: absolute;
      bottom: 0;
      left: 0;
      transition: width 0.4s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.3s ease;
      background-color: #f48e30;
    }

    .nav-list:hover {
      color: #f48e30;

      .icon-a-xiangyou4 {
        right: -4px;
        color: #f48e30;
      }
      .down-line {
        width: 100%;
      }
    }
  }
  .open {
    .nav-list {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

@media (max-width: 768px) {
  .nav-panel {
    width: min(320px, 84vw);
    min-width: 0;
    box-shadow: 18px 0 45px rgba(0, 0, 0, 0.18);

    .nav-head {
      min-height: 62px;
      padding: 8px 18px 0;

      .nav-close {
        width: 36px;
        height: 36px;
        font-size: 31px;
      }
    }
  }

  .contaier {
    .box {
      .nav {
        width: 50px;
      }
      .test-drive {
        width: 90px;
        line-height: 30px;
        font-size: 12px;
      }
    }
    .isOpen-box {
      padding: 16px 22px 30px;

      .nav-list {
        min-height: 52px;
        padding-right: 8px;
        margin-bottom: 11px;
        font-size: 18px;
        letter-spacing: 0.03em;
      }
      .icon-a-xiangyou4 {
        right: 0;
        font-size: 28px;
      }
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .nav-panel,
  .nav-panel::before,
  .contaier .isOpen-box .nav-list,
  .contaier .isOpen-box .icon-a-xiangyou4,
  .contaier .isOpen-box .down-line,
  .nav-panel .nav-head .nav-close {
    transition: none;
  }
}
</style>
